import React, { Component } from 'react'
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer, inject } from "mobx-react"
import Store from "app/stores/arrayPgt/dataManage"
import DataHeader from "./containers/DataHeader"
import DataTable from "./containers/DataTable"

@inject("arrayPgtManage") @observer
export default class index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
  }

  render() {
    return (
      <div className="datamanage-page pgd">
        <h2 className="page-title"><img alt="" src={dataIcon} />数据管理</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={this.store} />
        </div>
        <div>
          <DataTable store={this.store} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/data_manage/index.js